import { useTranslation } from "react-i18next";
import { useEntityProps } from "../utilsHooks";

export enum BadgeLevel {
  Newbie = 1,
  Advanced = 2,
  Experienced = 3,
  Expert = 4,
  Master = 5,
}

export const useBadgeLevel = () => {
  const { t } = useTranslation();

  const badgeLevels = {
    [BadgeLevel.Newbie]: {
      label: t("Badge.levelNewbie"),
    },
    [BadgeLevel.Advanced]: {
      label: t("Badge.levelAdvanced"),
    },
    [BadgeLevel.Experienced]: {
      label: t("Badge.levelExperienced"),
    },
    [BadgeLevel.Expert]: {
      label: t("Badge.levelExpert"),
    },
    [BadgeLevel.Master]: {
      label: t("Badge.levelMaster"),
    },
  } as Record<BadgeLevel, { label: string }>;
  const getProp = useEntityProps(badgeLevels);

  const getBadgeLevelLabel = getProp<string>("label");
  const badgeLevelList = Object.keys(badgeLevels).map(Number) as BadgeLevel[];

  return { getBadgeLevelLabel, badgeLevelList };
};
